import React, { useEffect, useState, useRef, useReducer } from "react";
import { Button, UncontrolledTooltip, Input } from "reactstrap";
import Select from "react-select";
import ConfirmationModal from "../ConfirmationModal";
import _ from "lodash";
import {
  deletePartition,
  updatePartitionComponent,
  addEqualShelves,
  addEqualPartitions,
  addAbsoluteShelf,
  addAbsoluteVerticals,
  updateSpaceSize,
  clearSpace,
  updateShutter,
  copyInternalsToSpace,
  copyTemplateToSpace,
  removeShutter,
  addShutter,
  mergeShutters,
  clearRootSpace,
  deleteWall,
  replaceModuleTemplate,
} from "../../product/service";
import { cloneItems } from "../service";
import {
  OptionImage,
  SpaceInfoButton,
  SpaceInfoButton2,
  SpaceButton,
} from "../../product/style";
import {
  CustomizationSpinnerContainer,
  Notification,
  Icon,
} from "../../common/style";
import { Spinner } from "reactstrap";
import { UI_RESTRICTED_PROPERTIES } from "../../constants";
import { ProjectButton } from "../style";
import { Products } from "../../product";
import { ReactComponent as ClearOverridesIcon } from "../../assets/img/clear_overrides.svg";

const RightPanel = ({
  isVisible,
  selectionManager,
  access,
  finalisedContexts,
  isOrderFinalised,
  currentSelection,
  setCurrentSelection,
  setIsLoading,
  deleteSelectedItems,
  currentRoom,
  projectId,
  loadRoom,
  refreshProjectSummary,
}) => {
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [notificationMessage, setNotificationMessage] = useState({});
  const [isRightPaneLoading, setIsRightPaneLoading] = useState(false);
  const [partitionType, setPartitionType] = useState("");
  const [modulesCategory, setModulesCategory] = useState("internal_submodule");
  const [removeOverrideConfirmationOpen, setRemoveOverrideConfirmationOpen] =
    useState(false);
  const [showDeleteWallConfirmation, setShowDeleteWallConfirmation] =
    useState(false);
  const [
    isRemoveShutterColorOverrideOpen,
    setIsRemoveShutterColorOverrideOpen,
  ] = useState(false);
  const [shelfSelection, setShelfSelection] = useState(false);
  const [currentChange, setCurrentChange] = useState(null);
  const [currentOption, setCurrentOption] = useState(null);
  const [removable, setRemovable] = useState(false);
  const [shelfPosition, setShelfPosition] = useState("");
  const [shelfDirection, setShelfDirection] = useState("");
  const [disableSave, setDisableSave] = useState(false);
  const [height, setHeight] = useState("");
  const [width, setWidth] = useState("");
  const [inputEnabledHeight, setInputEnabledHeight] = useState(false);
  const [inputEnabledWidth, setInputEnabledWidth] = useState(false);
  const [shutterHeight, setShutterHeight] = useState("");
  const [shutterWidth, setShutterWidth] = useState("");
  const [shutterColor, setShutterColor] = useState({});
  const [shutterCNCType, setShutterCNCType] = useState(null);
  const [shutterPatternType, setShutterPatternType] = useState(null);
  const [clearDimension, setClearDimension] = useState("");
  const [removeShutterConfirmationOpen, setRemoveShutterConfirmationOpen] =
    useState(false);
  const [addShutterConfirmationOpen, setAddShutterConfirmationOpen] =
    useState(false);
  const [mergeShutterConfirmationOpen, setMergeShutterConfirmationOpen] =
    useState(false);
  const [regenerateShuttersConfirmation, setRegenerateShuttersConfirmation] =
    useState(false);
  const [copyTemplateMethod, setCopyTemplateMethod] = useState(() => {});
  const [showItemsDeleteConfirmation, setShowItemsDeleteConfirmation] =
    useState(false);
  const selectionManagerRef = useRef(selectionManager);
  const isOrderFinalisedRef = useRef(isOrderFinalised);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [showMessageOnTemplateChange, setShowMessageOnTemplateChange] =
    useState({
      show: false,
      message: "",
      args: {},
    });
  const [shrinkLeft, setShrinkLeft] = useState(0);
  const [shrinkRight, setShrinkRight] = useState(0);
  const [shrinkTop, setShrinkTop] = useState(0);
  const [shrinkBottom, setShrinkBottom] = useState(0);
  const [disabledDirections, setDisabledShrinkDirections] = useState([]);
  const [activeInput, setActiveInput] = useState("");
  const [currentPanelIdentifier, setCurrentPanelIdentifier] = useState(null);
  const [clearSpaceConfirmationOpen, setClearSpaceConfirmationOpen] =
    useState(false);
  const [removePartitionConfirmationOpen, setRemovePartitionConfirmationOpen] =
    useState(false);
  const [showClearSpaceConfirmation, setShowClearSpaceConfirmation] =
    useState(false);

  const toggleClearAllSpaceConfirmation = () => {
    setShowClearSpaceConfirmation(!showClearSpaceConfirmation);
  };
  // Callbacks
  useEffect(() => {
    clearSpaceActionContext();
    clearShutterActionContext();

    const selectedItem = selectionManager.selection();
    if (isNotificationVisible) onDismissNotification();

    if (selectedItem) {
      if (selectedItem.type == "space") {
        setHeight(selectedItem.dimensions.height);
        setWidth(selectedItem.dimensions.width);
      } else if (selectedItem.type == "shutter") {
        setShutterHeight(selectedItem.dimensions["height"]);
        setShutterWidth(selectedItem.dimensions["width"]);
        setShutterCNCType(selectedItem.cnc_type);
        setShutterPatternType(selectedItem.pattern_type);
        if (selectedItem.shrink_offset) {
          setShrinkBottom((selectedItem.shrink_offset["bottom"] || 0) * -1);
          setShrinkLeft((selectedItem.shrink_offset["left"] || 0) * -1);
          setShrinkRight((selectedItem.shrink_offset["right"] || 0) * -1);
          setShrinkTop((selectedItem.shrink_offset["top"] || 0) * -1);
          setDisabledShrinkDirections(
            selectedItem.shrink_offset["disabled_directions"] || []
          );
        }
        if (selectedItem.overrides) {
          let finalShutterColor = {};
          selectedItem.component.panels.map((panel, panelIndex) => {
            let panelIdentifier = panel.identifier;
            let value = selectedItem.overrides[panelIdentifier]
              ? selectedItem.overrides[panelIdentifier]["external_color"]
              : null;
            if (value)
              finalShutterColor = {
                ...finalShutterColor,
                [panelIdentifier]: value.slice(1, value.length - 1),
              };
          });
          setShutterColor(finalShutterColor);
        } else setShutterColor({});
        setInputEnabledHeight(false);
        setInputEnabledWidth(false);
      } else if (selectedItem.type == "partition") {
        setPartitionType(selectedItem.component.identifier);
      } else if (selectedItem.type == "wall") {
        setHeight(selectionManager.selectedWall().dimensions.height);
        setWidth(selectionManager.selectedWall().dimensions.width);
      } else if (selectionManager.selectedModule()) {
        prepareForModuleEditing();
      }
    }

    if (
      selectionManager.selections().length > 1 &&
      selectionManager.areSelectionsHomogenous("shutter")
    ) {
      let finalShutterColor = {};
      let shutterColorHash = {};
      selectionManager.selections().forEach((shutter, shutterIndex) => {
        shutter.component.panels.forEach((panel, panelIndex) => {
          let panelIdentifier = panel.identifier;
          if (!shutterColorHash[panelIdentifier]) {
            shutterColorHash[panelIdentifier] = [];
          }
          if (shutter.overrides && shutter.overrides[panelIdentifier])
            shutter.overrides && shutter.overrides[panelIdentifier]
              ? shutterColorHash[panelIdentifier].push(
                  shutter.overrides[panelIdentifier]["external_color"]
                )
              : shutterColorHash[panelIdentifier].push(null);
        });
      });

      Object.keys(shutterColorHash).forEach((panelIdentifier) => {
        const uniqueValues = [...new Set(shutterColorHash[panelIdentifier])];
        if (
          uniqueValues.length === 1 &&
          shutterColorHash[panelIdentifier][0] != null
        ) {
          finalShutterColor[panelIdentifier] = shutterColorHash[
            panelIdentifier
          ][0].slice(1, shutterColorHash[panelIdentifier][0].length - 1);
        }
      });
      setShutterColor(finalShutterColor);
    }
  }, [currentSelection]);

  useEffect(() => {
    setDisableSave(
      ["fixed_shelf", "fixed_vertical"].includes(currentOption)
        ? !/^([1-9]\d*)$/.test(shelfPosition)
        : invalidPosition(shelfPosition) || !currentChange || !currentOption
    );
  }, [currentChange, currentOption, shelfPosition]);

  useEffect(() => {
    currentOption === "fixed_shelf"
      ? setShelfDirection("top")
      : setShelfDirection("left");
  }, [currentOption]);

  // Partition type change
  useEffect(() => {
    const updatedFilteredOptions = options.filter((option) => {
      if (
        partitionType === "vertical_partition" ||
        partitionType === "vertical_partition_full_depth"
      ) {
        return (
          option.key === "vertical_partition" ||
          option.key === "vertical_partition_full_depth"
        );
      } else {
        return (
          option.key !== "vertical_partition" &&
          option.key !== "vertical_partition_full_depth"
        );
      }
    });
    setFilteredOptions(updatedFilteredOptions);
  }, [partitionType]);

  useEffect(() => {
    if (currentRoom) {
      for (const group of currentRoom.groups) {
        if (!group.temp_id) {
          for (const module of group.modules) {
            // Populate properties in editable format.
            populateGroupedProperties(module);
          }
        }
      }

      currentRoom.modules.forEach((module) =>
        populateGroupedProperties(module)
      );
    }
  }, [currentRoom]);

  //   useEffect(() => {
  //     if (currentRoom) {
  //       const item =
  //         currentRoom.groups.length > 0
  //           ? currentRoom.groups[0]
  //           : currentRoom.modules.length > 0
  //           ? currentRoom.modules[0]
  //           : null;
  //       if (item) setCurrentSelection([item]);
  //     }

  //     if (version == 1 && selectionManager.selections().length > 0)
  //       setCurrentTab("info");

  //     setOpenRightPane(false);
  //     setPosition({ x: 200, y: 200 });
  //     setZoom(0.5);
  //   }, [version]);

  useEffect(() => {
    selectionManagerRef.current = selectionManager;
  }, [selectionManager]);

  useEffect(() => {
    isOrderFinalisedRef.current = isOrderFinalised;
  }, [isOrderFinalised]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (currentPanelIdentifier) updateShutterConfig(currentPanelIdentifier);

    return () => setCurrentPanelIdentifier(null);
  }, [shutterColor, shutterCNCType, shutterPatternType]);

  //   useEffect(() => {
  //     if (openRightPane) setCurrentTab("settings");
  //   }, [openRightPane]);

  const cloneSelectedItems = () => {
    if (isOrderFinalisedRef.current) return;

    setIsLoading?.(true);

    return cloneItems({
      projectId: projectId,
      roomId: currentRoom.id,
      items: selectionManagerRef.current.selections().map(({ type, id }) => ({
        type,
        id,
      })),
    })
      .then((response) => {
        selectionManager.triggerLoadRoom(
          selectionManagerRef.current.currentRoom().id,
          null,
          response.clone_items
        );
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsLoading?.(false));
  };

  const handleWallDelete = () => {
    deleteWall({
      projectId: projectId,
      wallId: selectionManager.selection().id,
    });
    selectionManager.clear();
    selectionManager.triggerLoadRoom(currentRoom.id);
  };

  const changeModuleTemplate = ({ projectId: pid, orderItemId, productId }) => {
    setIsRightPaneLoading(true);

    replaceModuleTemplate({
      projectId: pid,
      orderItemId,
      productId,
    })
      .then((orderItem) => {
        replaceModule(orderItem);
        selectionManager.select(selectionManager.findModule(orderItem.id));
        setShowMessageOnTemplateChange({ show: false, message: "", args: {} });
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const handleKeyDown = (event) => {
    // User is possibly working on an input element. Don't apply shortcut.
    if (event.target instanceof HTMLInputElement) return;
    if (event.target instanceof HTMLTextAreaElement) return;

    if (
      (event.key === "Delete" || event.key === "Backspace") &&
      selectionManagerRef.current.areSelectionsCanDelete() &&
      selectionManagerRef.current.selections().length > 0 &&
      !isOrderFinalisedRef.current &&
      access.customize_module
    )
      setShowItemsDeleteConfirmation(true);

    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "d" || event.key === "D") &&
      selectionManagerRef.current.canSelectionsClone() &&
      selectionManagerRef.current.selections().length > 0 &&
      !isOrderFinalisedRef.current
    ) {
      event.preventDefault();
      cloneSelectedItems();
    }

    // if (event.key === "Escape") setOpenRightPane(false);
  };

  const toggleRemoveShutterConfirmation = () =>
    setRemoveShutterConfirmationOpen(!removeShutterConfirmationOpen);

  const toggleAddShutterConfirmation = () =>
    setAddShutterConfirmationOpen(!addShutterConfirmationOpen);

  const toggleMergeShutterConfirmation = () =>
    setMergeShutterConfirmationOpen(!mergeShutterConfirmationOpen);

  const toggleShowItemsDeleteConfirmation = () =>
    setShowItemsDeleteConfirmation(!showItemsDeleteConfirmation);

  const toggleOverrideConfirmation = () =>
    setRemoveOverrideConfirmationOpen(!removeOverrideConfirmationOpen);

  const toggleShowDeleteWallConfirmation = () => {
    setShowDeleteWallConfirmation(!showDeleteWallConfirmation);
  };

  const toggleClearSpaceConfirmation = () => {
    setClearSpaceConfirmationOpen(!clearSpaceConfirmationOpen);
  };

  const toggleRemovePartitionConfirmation = () => {
    setRemovePartitionConfirmationOpen(!removePartitionConfirmationOpen);
  };

  const toggleInputHeight = () => {
    setInputEnabledHeight(!inputEnabledHeight);
  };

  const toggleInputWidth = () => {
    setInputEnabledWidth(!inputEnabledWidth);
  };

  const handleHeightChange = (e) => {
    setHeight(e.target.value);
  };

  const handleWidthChange = (e) => {
    setWidth(e.target.value);
  };

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const handleCancelForUpdateSpace = () => {
    setInputEnabledHeight(false);
    setInputEnabledWidth(false);
    selectionManager.clear();
  };

  const handleDeletePartition = () => {
    if (!selectionManager.selectedPartition()) return;

    setIsRightPaneLoading(true);
    const pathToDelete = selectionManager.selectedPartition().path;
    deletePartition({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      path: pathToDelete,
    })
      .then((template) => {
        replaceTemplate(template);
        selectionManager.select(selectionManager.activeModule());
        refreshProjectSummary();
      })
      .catch((error) => {
        console.error("Failed to delete partition:", error);
      })
      .finally(() => {
        setIsRightPaneLoading(false);
        toggleRemovePartitionConfirmation();
      });
  };

  const handleClearSpace = () => {
    setIsRightPaneLoading(true);
    const pathToDelete = selectionManager.selection().path;

    clearSpace({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      path: pathToDelete,
    })
      .then((template) => {
        replaceTemplate(template);
        refreshProjectSummary();
      })
      .catch((error) => {
        console.error("Failed to clear space:", error);
      })
      .finally(() => {
        setIsRightPaneLoading(false);
        toggleClearSpaceConfirmation();
      });
  };

  const handleUpdateSpace = () => {
    if (!height && !width) return;

    setIsRightPaneLoading(true);
    const pathToUpdate = selectionManager.selection().path;

    updateSpaceSize({
      projectId: projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      path: pathToUpdate,
      height: height !== "" ? parseInt(height) : null,
      width: width !== "" ? parseInt(width) : null,
    })
      .then((template) => {
        replaceTemplate(template);
        refreshProjectSummary();
        setInputEnabledHeight(false);
        setInputEnabledWidth(false);
      })
      .catch((error) => {
        const changingDimensions = inputEnabledHeight ? "Height" : "Width";

        setHeight(selectionManager.selection().dimensions?.height);
        setWidth(selectionManager.selection().dimensions?.width);

        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "danger",
          text: `${changingDimensions} can't be updated. Please check .`,
        });
      })
      .finally(() => {
        setIsRightPaneLoading(false);
        setInputEnabledHeight(false);
        setInputEnabledWidth(false);
      });
  };

  const handleUpdatePartition = (updatedPartition) => {
    if (!selectionManager.selectedPartition() || !updatedPartition) return;

    setIsRightPaneLoading(true);
    const pathToUpdate = selectionManager.selectedPartition().path;
    updatePartitionComponent({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      path: pathToUpdate,
      componentIdentifier: updatedPartition,
    })
      .then((template) => {
        replaceTemplate(template);
        refreshProjectSummary();
      })
      .catch((error) => {
        console.error("Failed to update partition:", error);
      })
      .finally(() => {
        setIsRightPaneLoading(false);
      });
  };

  const replaceModule = (updatedModule) => {
    populateGroupedProperties(updatedModule);
    const module = selectionManager.findModule(updatedModule.id);

    // Overwrite the module using the new one.
    Object.assign(module, updatedModule);
    forceUpdate();
  };

  const replaceTemplate = (template) => {
    if (selectionManager.areSelectionsHomogenous("shutter")) {
      replaceModule({
        ...selectionManager.findModule(
          selectionManager.selections()[0].order_item_id
        ),
        template: template,
      });
    } else {
      replaceModule({ ...selectionManager.activeModule(), template: template });
    }

    if (selectionManager.selectedSpace()) {
      selectionManager.select(
        selectionManager.findSpace(
          selectionManager.selectedSpace().path,
          selectionManager.activeModuleId()
        )
      );
    } else if (selectionManager.selectedPartition()) {
      selectionManager.select(
        selectionManager.findPartition(
          selectionManager.selectedPartition().path,
          selectionManager.activeModuleId()
        )
      );
    } else if (selectionManager.areSelectionsHomogenous("shutter")) {
      const shutters = selectionManager
        .selections()
        .map((s) =>
          template.shutters.find((e) => e.sequence_number == s.sequence_number)
        )
        .filter((e) => e);
      setCurrentSelection(shutters);
    }
  };

  const populateGroupedProperties = (orderItem) => {
    if (orderItem.is_old_mode || orderItem.temp_id) return;

    if (!orderItem.isPrepared) {
      const groupedProperties = _.groupBy(
        orderItem.property_list.filter(
          (property) =>
            !(
              UI_RESTRICTED_PROPERTIES.includes(property.uniq_id) ||
              orderItem.project_settings[property.uniq_id]
            )
        ),
        "header_name"
      );

      orderItem.groupedProperties = groupedProperties;
      orderItem.isPrepared = true;
    }
  };

  const prepareForModuleEditing = () => {
    const orderItem = selectionManager.selectedModule();
  };

  const clearSpaceActionContext = () => {
    setRemovable(null);
    setShelfSelection(null);
    setCurrentOption(null);
    setCurrentChange(null);
  };

  const clearShutterActionContext = () => {
    setInputEnabledHeight(false);
    setInputEnabledWidth(false);
  };

  const handleCopyTemplate = (productId, onlyInternals = true) => {
    const copyTemplateCache = () => {
      handleSpaceAction(
        onlyInternals ? copyInternalsToSpace : copyTemplateToSpace,
        {
          projectId,
          groupId: selectionManager.activeGroupId(),
          orderItemId: selectionManager.activeModuleId(),
          path:
            selectionManager.selection().replaceable_space_path ||
            selectionManager.selection().path,
          productId,
        }
      );
    };

    if (selectionManager.selectedSpace().is_shuttered && !onlyInternals) {
      setCopyTemplateMethod(() => copyTemplateCache);
      setRegenerateShuttersConfirmation(true);

      return;
    }

    copyTemplateCache();
  };

  const addShelves = () => {
    if (currentChange === "shelves" && currentOption !== "fixed_shelf")
      handleSpaceAction(addEqualShelves, {
        projectId,
        groupId: selectionManager.activeGroupId(),
        orderItemId: selectionManager.activeModuleId(),
        shelfCount: parseInt(currentOption.replace("shelf_", "")),
        path: selectionManager.selection().path,
        removable,
      });
    else if (currentChange === "shelves")
      handleSpaceAction(addAbsoluteShelf, {
        projectId,
        groupId: selectionManager.activeGroupId(),
        orderItemId: selectionManager.activeModuleId(),
        position: parseInt(shelfPosition),
        path: selectionManager.selection().path,
        removable,
        direction: shelfDirection,
      });
    else if (
      currentChange === "verticals" &&
      currentOption !== "fixed_vertical"
    )
      handleSpaceAction(addEqualPartitions, {
        projectId,
        groupId: selectionManager.activeGroupId(),
        orderItemId: selectionManager.activeModuleId(),
        verticalCount: parseInt(currentOption.replace("vertical_", "")),
        path: selectionManager.selection().path,
      });
    else {
      handleSpaceAction(addAbsoluteVerticals, {
        projectId,
        groupId: selectionManager.activeGroupId(),
        orderItemId: selectionManager.activeModuleId(),
        position: parseInt(shelfPosition),
        path: selectionManager.selection().path,
        direction: shelfDirection,
      });
    }
  };

  const handleSpaceAction = (actionFn, payload) => {
    setIsRightPaneLoading(true);
    actionFn(payload)
      .then((template) => {
        replaceTemplate(template);
        clearSpaceActionContext();
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const invalidPosition = (value) => {
    return !/^(|[1-9]\d*)$/.test(value);
  };

  const actions = [
    { label: "Add Shelves", value: "shelves" },
    { label: "Add Verticals", value: "verticals" },
  ];

  const options = [
    { key: "fixed_shelf", value: "Fixed Shelf" },
    { key: "fixed_shelf_full_depth", value: "Shutter Partition" },
    { key: "removable_shelf", value: "Removable Shelf" },
    { key: "vertical_partition", value: "Vertical Partition" },
    {
      key: "vertical_partition_full_depth",
      value: "Vertical Partition Full Depth",
    },
  ];

  const [filteredOptions, setFilteredOptions] = useState(options);

  const actions_options = {
    shelves: [
      { label: "Add 1 Shelf (eq)", value: "shelf_1" },
      { label: "Add 2 Shelves (eq)", value: "shelf_2" },
      { label: "Add 3 Shelves (eq)", value: "shelf_3" },
      { label: "Add 4 Shelves (eq)", value: "shelf_4" },
      { label: "Add 5 Shelves (eq)", value: "shelf_5" },
      { label: "Add 1 Shelf at fixed position", value: "fixed_shelf" },
    ],
    verticals: [
      { label: "Add 1 Partition (eq)", value: "vertical_1" },
      { label: "Add 2 Partition (eq)", value: "vertical_2" },
      { label: "Add 3 Partition (eq)", value: "vertical_3" },
      { label: "Add 4 Partition (eq)", value: "vertical_4" },
      { label: "Add 5 Partition (eq)", value: "vertical_5" },
      { label: "Add 1 Partition at fixed position", value: "fixed_vertical" },
    ],
  };

  const invalidShutterDimensions = (value) => {
    return !/^([1-9]\d*)$/.test(value);
  };

  const updateShutterConfig = (panelIdentifier = null) => {
    let payload = {
      items: [
        {
          sequence_number: selectionManager.selectedShutter().sequence_number,
          panel_identifier:
            panelIdentifier ||
            selectionManager.selectedShutter().component.panels[0].identifier,
        },
      ],
    };

    if (clearDimension) payload[clearDimension] = "";
    else {
      if (
        selectionManager.selectedShutter().dimensions["height"] != shutterHeight
      )
        payload.height = parseInt(shutterHeight);
      if (
        selectionManager.selectedShutter().dimensions["width"] != shutterWidth
      )
        payload.width = parseInt(shutterWidth);
      if (
        selectionManager.selectedShutter().overrides[panelIdentifier]?.[
          "external_color"
        ] != `'${shutterColor[panelIdentifier]}'`
      )
        payload.color = shutterColor[panelIdentifier];
      if (selectionManager.selectedShutter().cnc_type != shutterCNCType)
        payload.cnc_type = shutterCNCType;
      if (selectionManager.selectedShutter().pattern_type != shutterPatternType)
        payload.pattern_type = shutterPatternType;
      if (selectionManager.selectedShutter().shrink_offset) {
        payload.shrink_offset = {
          left: shrinkLeft !== null ? shrinkLeft * -1 : null,
          right: shrinkRight !== null ? shrinkRight * -1 : null,
          top: shrinkTop !== null ? shrinkTop * -1 : null,
          bottom: shrinkBottom !== null ? shrinkBottom * -1 : null,}
      };
    }

    handleShutterAction(updateShutter, payload, clearDimension);
  };

  const getBorderColor = (value) => (value !== 0 ? "#2C51E6" : "#999999");

  const updateShuttersConfig = (color, panelIdentifier = null) => {
    if (selectionManager.areSelectionsHomogenous("shutter")) {
      let payload = {
        items: selectionManager.selections().map((e) => ({
          sequence_number: e.sequence_number,
          panel_identifier: panelIdentifier || e.component.panels[0].identifier,
        })),
      };
      if (clearDimension) payload[clearDimension] = "";
      else payload["color"] = color;
      handleShutterAction(updateShutter, payload, clearDimension);
    }
  };

  const handleShutterAction = (actionFn, payload) => {
    setIsRightPaneLoading(true);
    const module = selectionManager.findModule(
      selectionManager.selections()[0].order_item_id
    );

    actionFn({
      projectId,
      groupId: module.group_id,
      orderItemId: module.id,
      payload,
    })
      .then((template) => {
        const shutterSeq = selectionManager.selectedShutter()?.sequence_number;
        const dimBeingCleared = clearDimension;
        refreshProjectSummary();
        replaceTemplate(template);
        selectionManager.clear();

        if (dimBeingCleared) {
          setClearDimension("");
          const updatedShutter = template.shutters?.find(
            (s) => s.sequence_number === shutterSeq
          );
          if (updatedShutter) {
            if (dimBeingCleared === "height")
              setShutterHeight(updatedShutter.dimensions["height"]);
            if (dimBeingCleared === "width")
              setShutterWidth(updatedShutter.dimensions["width"]);
            if (dimBeingCleared === "color") setShutterColor({});
          }
        } else {
          setInputEnabledHeight(false);
          setInputEnabledWidth(false);
        }

        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const removeSelectedShutter = () => {
    const payload = {
      sequence_number: selectionManager.selectedShutter().sequence_number,
      panel_identifier: selectionManager.selectedShutter().identifier,
    };

    setIsRightPaneLoading(true);
    removeShutter({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      payload,
    })
      .then((template) => {
        toggleRemoveShutterConfirmation();
        refreshProjectSummary();
        replaceTemplate(template);
        selectionManager.clear();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const addRemovedShutter = () => {
    const payload = {
      sequence_number: selectionManager.selectedShutter().sequence_number,
      panel_identifier: selectionManager.selectedShutter().identifier,
    };

    setIsRightPaneLoading(true);
    addShutter({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
      payload,
    })
      .then((template) => {
        toggleAddShutterConfirmation();
        refreshProjectSummary();
        replaceTemplate(template);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const handleClearRootSpace = () => {
    setIsRightPaneLoading(true);

    clearRootSpace({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId: selectionManager.activeModuleId(),
    })
      .then((orderItem) => {
        replaceTemplate(orderItem.template);
        replaceModule(orderItem);
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "danger",
          text: error,
        });
      })
      .finally(() => {
        setIsRightPaneLoading(false);
        toggleClearAllSpaceConfirmation();
      });
  };

  if (!isVisible) return null;

  const mergeSelectedShutter = () => {
    const payload = {
      sequence_number: selectionManager
        .selections()
        .map((e) => e.sequence_number),
    };
    const module = selectionManager.findModule(
      selectionManager.selections()[0].order_item_id
    );

    setIsRightPaneLoading(true);
    mergeShutters({
      projectId,
      groupId: module.group_id,
      orderItemId: module.id,
      payload,
    })
      .then((template) => {
        replaceTemplate(template);
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  return !currentRoom ? (
    <div className="position-relative">
      <CustomizationSpinnerContainer top="200px" left="40%">
        <Spinner />
      </CustomizationSpinnerContainer>
    </div>
  ) : (
    <>
      {notificationMessage.text && (
        <Notification
          color={notificationMessage.type}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notificationMessage.text}
        </Notification>
      )}
      <div
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          width: "75%",
          height: "100%",
          backgroundColor: "var(--bg-light-1)",
          boxShadow: "-4px 0 15px rgba(0,0,0,0.2)",
          zIndex: 1000,
          overflowY: "auto",
          borderLeft: "1px solid #ddd",
        }}
        className="border-bottom"
      >
        {" "}
        <div
        //   className={`right-pane fh position-relative overflow-hidden ${
        //     (["catalog", "materials", "project_import", "order"].includes(
        //       currentTab
        //     ) ||
        //       showReplaceTemplate) &&
        //     "wide"
        //   }`}
        >
          <>
            <div className={`fh ${isRightPaneLoading ? "blurred" : ""}`}>
              {shelfSelection ? (
                <div>
                  <div className="d-flex align-items-center border-bottom p-3">
                    <i
                      onClick={() => {
                        clearSpaceActionContext();
                      }}
                      className="fa-solid fa-arrow-left fs-6 pointer"
                    />
                    <p className="fw-bold fs-14px m-0 ms-3">Partitions</p>
                  </div>
                  <div className="p-4 border-bottom">
                    <Select
                      options={actions}
                      value={actions.find((e) => e.value === currentChange)}
                      onChange={(option) => {
                        setCurrentChange(option.value);
                        setCurrentOption(null);
                      }}
                      placeholder="Select a change"
                    />
                  </div>
                  {currentChange && (
                    <div className="p-4 border-bottom">
                      <Select
                        options={actions_options[currentChange]}
                        value={
                          actions_options[currentChange].find(
                            (e) => e.value === currentOption
                          ) || null
                        }
                        onChange={(option) => {
                          setCurrentOption(option.value);
                          setShelfPosition("");
                        }}
                        placeholder="Select a option"
                      />
                    </div>
                  )}
                  {currentOption &&
                    ![
                      "vertical_1",
                      "vertical_2",
                      "vertical_3",
                      "vertical_4",
                      "vertical_5",
                    ].includes(currentOption) && (
                      <div className="p-4 border-bottom">
                        <div className="d-flex column-gap-3">
                          {(currentOption == "fixed_shelf" ||
                            currentOption == "fixed_vertical") && (
                            <>
                              <div className="d-flex align-items-center column-gap-2">
                                <Input
                                  value={shelfPosition}
                                  style={{ width: "70px" }}
                                  type="text"
                                  onChange={(ev) =>
                                    setShelfPosition(ev.target.value)
                                  }
                                  invalid={invalidPosition(shelfPosition)}
                                />
                                <span className="text-body-tertiary">mm</span>
                              </div>
                              <div className="d-flex align-items-center column-gap-2">
                                <span className="fw-semibold">from</span>

                                <Input
                                  value={shelfDirection}
                                  onChange={(event) =>
                                    setShelfDirection(event.target.value)
                                  }
                                  style={{ width: "80px" }}
                                  type="select"
                                >
                                  {currentChange === "shelves" ? (
                                    <>
                                      <option value="top">top</option>
                                      <option value="bottom">bottom</option>
                                    </>
                                  ) : (
                                    <>
                                      <option value="left">left</option>
                                      <option value="right">right</option>
                                    </>
                                  )}
                                </Input>
                              </div>
                            </>
                          )}
                          {currentChange === "shelves" && (
                            <div className="d-flex align-items-center column-gap-2">
                              <Input
                                className="m-0"
                                onChange={() => setRemovable(!removable)}
                                type="checkbox"
                                checked={removable}
                              />
                              <span className="fw-semibold">Removable</span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  <div className="d-flex p-4 column-gap-3">
                    <ProjectButton
                      onClick={() => addShelves()}
                      className="rounded-1"
                      disabled={disableSave}
                    >
                      Add Partition
                    </ProjectButton>

                    <Button
                      onClick={() => {
                        clearSpaceActionContext();
                      }}
                      className="rounded-1"
                      outline
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              ) : selectionManager.selectedSpace() ? (
                <>
                  <div className="info-header d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <i
                        onClick={() => {
                          selectionManager.clear();
                        }}
                        className="fa-solid fa-arrow-left fs-6 pointer"
                      />
                      <p className="fw-bold fs-14px m-0 ms-2">
                        {" "}
                        Selected Space
                      </p>
                    </div>
                  </div>
                  <div className="p-3 border-bottom">
                    <div className="d-flex justify-content-between align-items-center ">
                      <div className="d-flex align-items-center gap-2">
                        {selectionManager.selectedSpace().is_leaf_space &&
                        !selectionManager.selectedSpace().is_drawer ? (
                          <SpaceInfoButton
                            onClick={() => setShelfSelection(true)}
                            className="rounded-2"
                            color="#2C92E6"
                            size="sm"
                            disabled={
                              finalisedContexts.includes("carcass") ||
                              !access.customize_module
                            }
                          >
                            <i className="fa-solid fa-circle-plus me-2"></i>
                            Add Partitions
                          </SpaceInfoButton>
                        ) : (
                          selectionManager.selectedSpace().can_be_cleared && (
                            <SpaceButton
                              className="rounded-2"
                              color="#dc3545"
                              outline
                              size="sm"
                              onClick={toggleClearSpaceConfirmation}
                              disabled={
                                finalisedContexts.includes("carcass") ||
                                finalisedContexts.includes("shutter") ||
                                !access.customize_module
                              }
                            >
                              <ClearOverridesIcon
                                style={{ width: "12px", height: "15px" }}
                                className="icon-red me-2 mb-1"
                              />
                              Clear Space
                            </SpaceButton>
                          )
                        )}

                        <SpaceInfoButton2
                          className="rounded-2"
                          color="#dc3545"
                          outline
                          size="sm"
                          onClick={toggleClearAllSpaceConfirmation}
                          disabled={
                            finalisedContexts.includes("carcass") ||
                            finalisedContexts.includes("shutter") ||
                            !access.customize_module
                          }
                        >
                          <ClearOverridesIcon
                            style={{ width: "12px", height: "15px" }}
                            className="icon-white me-1 mb-1"
                          />{" "}
                          Clear Internals
                        </SpaceInfoButton2>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 pb-0">
                    <div className="d-flex column-gap-2 align-items-center">
                      <div className="d-flex align-items-center">
                        <Input
                          style={{ width: "70px" }}
                          type="text"
                          value={height}
                          onChange={handleHeightChange}
                          disabled={
                            !inputEnabledHeight || !access.customize_module
                          }
                          invalid={invalidShutterDimensions(height)}
                        />
                        <span className="ms-2 text-body-tertiary">H</span>
                        {!finalisedContexts.includes("carcass") && (
                          <i
                            className="fa-solid fa-pencil-alt"
                            style={{
                              cursor: "pointer",
                              marginLeft: "5px",
                              color: "grey",
                              visibility: !inputEnabledHeight
                                ? "visible"
                                : "hidden",
                            }}
                            onClick={toggleInputHeight}
                          ></i>
                        )}
                      </div>
                      <div className="d-flex align-items-center">
                        <Input
                          style={{ width: "70px" }}
                          type="text"
                          value={width}
                          onChange={handleWidthChange}
                          invalid={invalidShutterDimensions(width)}
                          disabled={
                            !inputEnabledWidth || !access.customize_module
                          }
                        />
                        <span className="ms-2 text-body-tertiary">W</span>
                        {!finalisedContexts.includes("carcass") && (
                          <i
                            className="fa-solid fa-pencil-alt"
                            style={{
                              cursor: "pointer",
                              marginLeft: "5px",
                              color: "grey",
                              visibility: !inputEnabledWidth
                                ? "visible"
                                : "hidden",
                            }}
                            onClick={toggleInputWidth}
                          ></i>
                        )}
                      </div>
                    </div>
                  </div>
                  <hr></hr>

                  {(inputEnabledHeight || inputEnabledWidth) && (
                    <div className="p-3 mr-3 pt-0">
                      <div className="d-flex column-gap-3">
                        <ProjectButton
                          onClick={handleUpdateSpace}
                          className="rounded-2"
                        >
                          Update Space
                        </ProjectButton>
                        <Button
                          onClick={handleCancelForUpdateSpace}
                          className="rounded-1"
                          outline
                        >
                          Cancel
                        </Button>
                      </div>
                    </div>
                  )}

                  {access.customize_module && (
                    <div className="px-2 mt-3 border-top">
                      <Products
                        modulesCategory={modulesCategory}
                        handleCopyTemplate={handleCopyTemplate}
                        spaceDimensions={
                          selectionManager.selectedSpace().dimensions
                        }
                        isSpaceShuttered={
                          selectionManager.selectedSpace().is_shuttered
                        }
                        selectedSpacePath={
                          selectionManager.selectedSpace().path
                        }
                        projectId={projectId}
                        loadRoom={loadRoom}
                        selectionManager={selectionManager}
                        currentRoom={currentRoom}
                      />
                    </div>
                  )}

                  <ConfirmationModal
                    isOpen={clearSpaceConfirmationOpen}
                    toggle={toggleClearSpaceConfirmation}
                    onConfirm={handleClearSpace}
                    message="Are you sure you want to clear partitions?"
                    headingText="Clear Partitions Confirmation"
                  />
                </>
              ) : selectionManager.selectedPartition() ? (
                <>
                  <div>
                    <div className="info-header">
                      <div className="d-flex align-items-center">
                        <Icon
                          onClick={() => selectionManager.clear()}
                          className="fa-solid fa-arrow-left fs-6 pointer"
                        />
                        <h4 className="fw-bold fs-14px m-0 ms-3">Partition</h4>
                      </div>
                      <SpaceInfoButton
                        className="rounded-2"
                        color="#dc3545"
                        outline
                        size="sm"
                        onClick={toggleRemovePartitionConfirmation}
                        disabled={
                          finalisedContexts.includes("carcass") ||
                          finalisedContexts.includes("shutter") ||
                          selectionManager.selectedPartition().immutable ||
                          !access.customize_module
                        }
                      >
                        <i className="fa-regular fa-trash-can me-2"></i>
                        Remove Partition
                      </SpaceInfoButton>
                    </div>
                    <div className="p-4 border-bottom">
                      <Select
                        options={filteredOptions
                          .filter(
                            (option) => option.key !== "fixed_shelf_full_depth"
                          )
                          .map((option) => ({
                            value: option.key,
                            label: option.value,
                          }))}
                        value={
                          filteredOptions.find(
                            (option) => option.key === partitionType
                          )
                            ? {
                                value: partitionType,
                                label: filteredOptions.find(
                                  (option) => option.key === partitionType
                                ).value,
                              }
                            : null
                        }
                        onChange={(selectedOption) => {
                          const updatedPartition = selectedOption
                            ? selectedOption.value
                            : "";
                          setPartitionType(updatedPartition);
                          handleUpdatePartition(updatedPartition);
                        }}
                        isDisabled={
                          selectionManager.selectedPartition().immutable ||
                          !access.customize_module ||
                          partitionType === "fixed_shelf_full_depth"
                        }
                        placeholder="Select a type"
                      />
                    </div>
                  </div>
                  <ConfirmationModal
                    isOpen={removePartitionConfirmationOpen}
                    toggle={toggleRemovePartitionConfirmation}
                    onConfirm={handleDeletePartition}
                    message="Are you sure you want to remove this partition?"
                    headingText="Remove Partition Confirmation"
                  />
                </>
              ) : selectionManager.selectedShutter() &&
                selectionManager.activeModule().groupedProperties ? (
                <>
                  <div className="info-header">
                    <div className="d-flex align-items-center">
                      <p className="fw-bold fs-14px m-0">Shutter</p>
                      {selectionManager.selectedShutter().is_removed && (
                        <p className="ms-2 text-secondary m-0">removed</p>
                      )}
                    </div>
                    <i
                      onClick={() => {
                        selectionManager.clear();
                      }}
                      className="fa-solid fa-close pointer fs-5"
                    />
                  </div>
                  {selectionManager.selectedShutter().is_removed ? (
                    <div className="d-flex justify-content-center p-4 border-bottom">
                      <SpaceInfoButton
                        className="rounded-2"
                        color="#2C92E6"
                        disabled={!access.customize_shutter}
                        outline
                        size="sm"
                        onClick={() => toggleAddShutterConfirmation()}
                      >
                        <i className="fa-solid fa-arrow-rotate-left me-2"></i>
                        Revert Shutter
                      </SpaceInfoButton>
                    </div>
                  ) : (
                    <>
                      {access.customize_shutter && <div className="border-bottom p-3">
                        {!selectionManager.selectedShutter().is_removed && (
                          <i
                            className="fa-regular fa-trash-can me-2 fs-6 pointer"
                            disabled={!access.customize_shutter}
                            onClick={toggleRemoveShutterConfirmation}
                          ></i>
                        )}
                      </div>}
                      <div className="ps-3 pt-3 pb-1 border-bottom">
                        <p className="text-uppercase property-name m-0 fw-bold">
                          Size
                        </p>
                        <div className="d-flex column-gap-4 mt-1">
                          <div className="d-flex flex-column row-gap-2">
                            <div className="d-flex align-items-center">
                              <span>{shutterHeight}</span>
                              <span className="ms-2 text-body-tertiary">H</span>
                            </div>
                            <div className="d-flex align-items-center">
                              {selectionManager.selectedShutter().overrides
                                .shutter?.["length_1"] && (
                                <>
                                  <div>
                                    <i
                                      className="fa-solid fa-circle-info me-2 text-secondary fs-6"
                                      id="fixed"
                                    />
                                  </div>
                                  <UncontrolledTooltip
                                    target="fixed"
                                    placement="bottom"
                                  >
                                    Size Customized
                                  </UncontrolledTooltip>
                                </>
                              )}
                              {selectionManager.selectedShutter().overrides
                                .shutter?.["length_1"] && (
                                <i
                                  onClick={() => {
                                    setClearDimension("height");
                                    toggleOverrideConfirmation(
                                      !removeOverrideConfirmationOpen
                                    );
                                  }}
                                  className="fa-solid fa-arrow-rotate-left text-primary"
                                ></i>
                              )}
                            </div>
                          </div>
                          <div className="d-flex flex-column row-gap-2">
                            <div className="d-flex align-items-center">
                              <span>{shutterWidth}</span>
                              <span className="ms-2 text-body-tertiary">W</span>
                            </div>
                            <div className="d-flex align-items-center">
                              {selectionManager.selectedShutter().overrides
                                .shutter?.["length_2"] && (
                                <>
                                  <div>
                                    <i
                                      className="fa-solid fa-circle-info me-2 text-secondary fs-6"
                                      id="fixed"
                                    />
                                  </div>
                                  <UncontrolledTooltip
                                    target="fixed"
                                    placement="bottom"
                                  >
                                    Size Customized
                                  </UncontrolledTooltip>
                                </>
                              )}
                              {selectionManager.selectedShutter().overrides
                                .shutter?.["length_2"] && (
                                <i
                                  onClick={() => {
                                    setClearDimension("width");
                                    toggleOverrideConfirmation(
                                      !removeOverrideConfirmationOpen
                                    );
                                  }}
                                  className="fa-solid fa-arrow-rotate-left text-primary"
                                ></i>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {selectionManager.selectedShutter()
                        .can_dimension_change && (
                        <div className="px-3 pt-3 pb-0 border-bottom">
                          <p className="text-uppercase property-name mt-0 fw-bold">
                            Size Extensions
                          </p>
                          <div className="d-flex flex-column align-items-center mt-1">
                            <div className="mb-2 text-center">
                              <p className="mb-1" style={{ color: "#999999" }}>
                                Top
                              </p>
                              <input
                                type="number"
                                value={shrinkTop}
                                onChange={(e) => {
                                  setShrinkTop(e.target.value === "" ? null : parseInt(e.target.value))
                                }
                                }
                                onFocus={() => setActiveInput("top")}
                                onBlur={() => {
                                  updateShutterConfig(
                                    shrinkLeft,
                                    shrinkRight,
                                    shrinkTop,
                                    shrinkBottom
                                  );
                                  setActiveInput("");
                                }}
                                disabled={
                                  selectionManager.selectedShutter().overrides
                                    .shutter?.["length_1"] ||
                                  selectionManager.selectedShutter().overrides
                                    .shutter?.["length_2"] ||
                                  !access.customize_shutter ||
                                  disabledDirections.includes("top")
                                }
                                className="form-control text-center"
                                style={{
                                  width: "70px",
                                  border: "1px solid #cccccc",
                                  color:
                                    shrinkTop === 0 ? "#999999" : "#2C51E6",
                                }}
                              />
                            </div>

                            <div className="d-flex justify-content-center align-items-center w-100">
                              <div className="me-3 text-center mb-4">
                                <p
                                  className="mb-1"
                                  style={{ color: "#999999" }}
                                >
                                  Left
                                </p>
                                <input
                                  type="number"
                                  value={shrinkLeft}
                                  onChange={(e) =>
                                    setShrinkLeft(
                                      (e.target.value === "" ? null : parseInt(e.target.value))
                                    )
                                  }
                                  onFocus={() => setActiveInput("left")}
                                  onBlur={() => {
                                    updateShutterConfig(
                                      shrinkLeft,
                                      shrinkRight,
                                      shrinkTop,
                                      shrinkBottom
                                    );
                                    setActiveInput("");
                                  }}
                                  disabled={
                                    selectionManager.selectedShutter().overrides
                                      .shutter?.["length_1"] ||
                                    selectionManager.selectedShutter().overrides
                                      .shutter?.["length_2"] ||
                                    !access.customize_shutter ||
                                    disabledDirections.includes("left")
                                  }
                                  className="form-control text-center"
                                  style={{
                                    width: "70px",
                                    border: "1px solid #cccccc",
                                    color:
                                      shrinkLeft === 0 ? "#999999" : "#2C51E6",
                                  }}
                                />
                              </div>

                              <div
                                className="d-flex justify-content-center align-items-center"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  borderTop: `3px solid ${getBorderColor(
                                    shrinkTop
                                  )}`,
                                  borderLeft: `3px solid ${getBorderColor(
                                    shrinkLeft
                                  )}`,
                                  borderRight: `3px solid ${getBorderColor(
                                    shrinkRight
                                  )}`,
                                  borderBottom: `3px solid ${getBorderColor(
                                    shrinkBottom
                                  )}`,
                                }}
                              >
                                Panel
                              </div>

                              <div className="ms-3 text-center mb-4">
                                <p
                                  className="mb-1"
                                  style={{ color: "#999999" }}
                                >
                                  Right
                                </p>
                                <input
                                  type="number"
                                  value={shrinkRight}
                                  onChange={(e) =>
                                    setShrinkRight(
                                      (e.target.value === "" ? null : parseInt(e.target.value))
                                    )
                                  }
                                  onFocus={() => setActiveInput("right")}
                                  onBlur={() => {
                                    updateShutterConfig(
                                      shrinkLeft,
                                      shrinkRight,
                                      shrinkTop,
                                      shrinkBottom
                                    );
                                    setActiveInput("");
                                  }}
                                  disabled={
                                    selectionManager.selectedShutter().overrides
                                      .shutter?.["length_1"] ||
                                    selectionManager.selectedShutter().overrides
                                      .shutter?.["length_2"] ||
                                    !access.customize_shutter ||
                                    disabledDirections.includes("right")
                                  }
                                  className="form-control text-center"
                                  style={{
                                    width: "70px",
                                    border: "1px solid #cccccc",
                                    color:
                                      shrinkRight === 0 ? "#999999" : "#2C51E6",
                                  }}
                                />
                              </div>
                            </div>

                            <div className="mt-2 text-center">
                              <input
                                type="number"
                                value={shrinkBottom}
                                onChange={(e) =>
                                  setShrinkBottom(
                                    (e.target.value === "" ? null : parseInt(e.target.value))
                                  )
                                }
                                onFocus={() => setActiveInput("bottom")}
                                onBlur={() => {
                                  updateShutterConfig(
                                    shrinkLeft,
                                    shrinkRight,
                                    shrinkTop,
                                    shrinkBottom
                                  );
                                  setActiveInput("");
                                }}
                                disabled={
                                  selectionManager.selectedShutter().overrides
                                    .shutter?.["length_1"] ||
                                  selectionManager.selectedShutter().overrides
                                    .shutter?.["length_2"] ||
                                  !access.customize_shutter ||
                                  disabledDirections.includes("bottom")
                                }
                                className="form-control text-center mx-auto"
                                style={{
                                  width: "70px",
                                  border: "1px solid #cccccc",
                                  color:
                                    shrinkBottom === 0 ? "#999999" : "#2C51E6",
                                }}
                              />
                              <p className="pt-1" style={{ color: "#999999" }}>
                                Bottom
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                      {selectionManager
                        .selectedShutter()
                        .component.panels.map((panel, panelIndex) => (
                          <div className="p-3 border-bottom">
                            {(() => {
                              const options = selectionManager
                                .activeModule()
                                .groupedProperties[null].find(
                                  (e) => e.identifier === "color"
                                ).options;
                              const selectedOption = options.find(
                                (e) =>
                                  e.identifier ===
                                  shutterColor[panel.identifier]
                              );
                              return (
                                <>
                                  <p className="text-uppercase property-name mt-0 mb-1 fw-bold">
                                    {panel.name} color
                                  </p>
                                  <div className="mt-2 text-muted small">
                                    Moved to ‘Color’ column in the table.
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        ))}

                      <div className="p-3 border-bottom">
                        {(() => {
                          const options = [
                              { label: "None", value: "none" },
                              { label: "Pooja Bells", value: "simple" },
                              { label: "Pooja Curve / Flower", value: "complex" },
                              { label: "Horizontal Air Vent Groove", value: "horizontal_air_vent_groove" },
                              { label: "Glass Rectangle Cut", value: "glass_rectangle_cut" },
                              { label: "Louver Fixing Rectangle Cut", value: "louver_fixing_rectangle_cut" },
                              { label: "Wardrobe Cross Groove", value: "wardrobe_cross_groove" },
                              { label: "Wardrobe Horizontal Groove", value: "wardrobe_horizontal_groove" },
                              { label: "Wardrobe Vertical Groove", value: "wardrobe_vertical_groove" },
                              { label: "T Profile Groove", value: "t_profile_groove" },
                              { label: "Rectangle Cut with Step", value: "rectangle_cut_with_step" },
                              { label: "4mm Layer", value: "four_mm_layer" },
                              { label: "Panel Curve Cut", value: "panel_curve_cut" },
                              { label: "Edge Handle Cut", value: "edge_handle_cut" }
                          ];
                          const selectedOption = options.find(
                            (e) => e.value === shutterCNCType
                          );

                          return (
                            <>
                              <p className="text-uppercase property-name mt-0 mb-1 fw-bold">
                                CNC Type
                              </p>
                              <div className="mt-2 text-muted small">
                                Moved to ‘Extras’ column in the table.
                              </div>
                            </>
                          );
                        })()}
                      </div>
                      {/*PATTERN TYPE*/}
                      <div className="p-3 border-bottom">
                        {(() => {
                          const options = [
                            { label: "None", value: "none" },
                            { label: "Horizontal Center", value: "simple" },
                            { label: "Zig Zag", value: "complex" },
                            { label: "Vertical Center", value: "vertical_center" },
                            { label: "Vertical Corner", value: "vertical_corner" },
                            { label: "Center Rectangle with Border", value: "center_rectangle_with_border" },
                            { label: "Arch", value: "arch" },
                            { label: "Horizontal 3 Color", value: "horizontal_3_color" },
                            { label: "Horizontal 4 Color", value: "horizontal_4_color" }
                          ];
                          const selectedOption = options.find(
                            (e) => e.value === shutterPatternType
                          );

                          return (
                            <>
                              <p className="text-uppercase property-name mt-0 mb-1 fw-bold">
                                Pattern Type
                              </p>
                              <div className="mt-2 text-muted small">
                                Moved to ‘Extras’ column in the table.
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    </>
                  )}
                </>
              ) : selectionManager.selections().length > 1 &&
                selectionManager.areSelectionsHomogenous("shutter") ? (
                <>
                  <div
                    className="d-flex justify-content-between align-items-center p-3 border-bottom text-capitalize"
                    style={{ background: "#D9D9D9" }}
                  >
                    <h6 className="m-0 fw-bold">
                      {selectionManager.selections().length +
                        " " +
                        (selectionManager.areSelectionsHomogenous()
                          ? selectionManager.selections()[0].type + "s"
                          : "")}{" "}
                      selected
                    </h6>
                    <i
                      className="fa-solid fa-close fs-5 text-secondary pointer"
                      onClick={() => selectionManager.clear()}
                    />
                  </div>
                  <div className="p-3 border-bottom d-flex justify-content-center">
                    <Button
                      className="bg-primary border-0 rounded-1"
                      onClick={
                        access.customize_shutter &&
                        toggleMergeShutterConfirmation
                      }
                    >
                      Merge Shutters
                    </Button>
                  </div>
                  {access.customize_shutter &&
                    selectionManager
                      .selections()
                      .every(
                        (selection) => selection.component.panels.length === 1
                      ) && (
                      <div className="p-3 border-bottom">
                        {(() => {
                          const options = selectionManager
                            .findModule(
                              selectionManager.selections()[0].order_item_id
                            )
                            .groupedProperties[null].find(
                              (e) => e.identifier === "color"
                            ).options;
                          const isOverriden = selectionManager
                            .selections()
                            .some(
                              (e) => e.overrides.shutter?.["external_color"]
                            );
                          const selectedOption = options.find(
                            (e) => e.identifier === shutterColor["shutter"]
                          );
                          return (
                            <>
                              <p className="text-uppercase property-name mt-0 mb-1 fw-bold">
                                shutter color
                              </p>
                              <div className="d-flex align-items-center">
                                <Select
                                  isDisabled={finalisedContexts.includes(
                                    "shutter"
                                  )}
                                  className="flex-grow-1"
                                  options={options.map((option) => ({
                                    label: option.name,
                                    value: option.identifier,
                                  }))}
                                  value={
                                    selectedOption
                                      ? {
                                          label: selectedOption.name,
                                          value: selectedOption.identifier,
                                        }
                                      : null
                                  }
                                  onChange={(e) => {
                                    // FIX HERE
                                    setShutterColor(e.value);
                                    updateShuttersConfig(e.value);
                                  }}
                                />
                                {!finalisedContexts.includes("shutter") &&
                                  isOverriden && (
                                    <i
                                      className="ms-3 fa-solid fa-arrow-rotate-left text-primary"
                                      onClick={() => {
                                        // FIXME
                                        setClearDimension("color");
                                        setIsRemoveShutterColorOverrideOpen(
                                          true
                                        );
                                      }}
                                    ></i>
                                  )}
                              </div>
                              {isOverriden ? (
                                <div className="invalid-feedback d-block text-secondary">
                                  <i style={{ color: "black" }}>
                                    (Some shutter colors are overridden)
                                  </i>
                                </div>
                              ) : (
                                <div className="invalid-feedback d-block text-secondary">
                                  {
                                    options.find((option) => option.selected)
                                      .name
                                  }
                                  &nbsp;
                                  <i style={{ color: "black" }}>
                                    (using from module settings)
                                  </i>
                                </div>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    )}
                </>
              ) : (
                <div className="fh d-flex justify-content-center align-items-center fs-6 text-secondary">
                  Select any object to customise.
                </div>
              )}
            </div>
          </>
        </div>
      </div>
      =
      <ConfirmationModal
        isOpen={removeOverrideConfirmationOpen}
        toggle={toggleOverrideConfirmation}
        onConfirm={() => updateShutterConfig()}
        message={`${`Are you sure you want to reset to default ${clearDimension}`}`}
        headingText={`${"Clear Fixed Dimension"}`}
      />
      <ConfirmationModal
        isOpen={isRemoveShutterColorOverrideOpen}
        toggle={() => setIsRemoveShutterColorOverrideOpen(false)}
        onConfirm={() => {
          selectionManager.selections.length === 1
            ? updateShutterConfig(null, currentPanelIdentifier)
            : updateShuttersConfig(null, currentPanelIdentifier);
          setCurrentPanelIdentifier(null);
        }}
        message="Are you sure you want to reset the shutter color?"
        headingText="Reset shutter color"
      />
      <ConfirmationModal
        isOpen={removeShutterConfirmationOpen}
        toggle={toggleRemoveShutterConfirmation}
        onConfirm={() => removeSelectedShutter()}
        message="Are you sure you want to remove the shutter"
        headingText="Remove Shutter"
      />
      <ConfirmationModal
        isOpen={addShutterConfirmationOpen}
        toggle={toggleAddShutterConfirmation}
        onConfirm={() => addRemovedShutter()}
        message="Are you sure you want to add the shutter"
        headingText="Add Shutter"
      />
      <ConfirmationModal
        isOpen={regenerateShuttersConfirmation}
        toggle={() => setRegenerateShuttersConfirmation(false)}
        onConfirm={() => {
          copyTemplateMethod();
        }}
        message="Some shutters will be regenerated after this change. Do you want to continue?"
        headingText="Confirm Regeneration"
      />
      <ConfirmationModal
        isOpen={showDeleteWallConfirmation}
        toggle={toggleShowDeleteWallConfirmation}
        onConfirm={() => handleWallDelete()}
        message="Are you sure you want to delete this wall?"
        headingText="Delete Wall"
      />
      <ConfirmationModal
        isOpen={showItemsDeleteConfirmation}
        toggle={toggleShowItemsDeleteConfirmation}
        onConfirm={() => deleteSelectedItems(selectionManager.selections())}
        message={`Are you sure you want to delete ${
          selectionManager.selections().length
        } item${selectionManager.selections().length > 1 ? "s" : ""}`}
        headingText="Delete Items"
      />
      <ConfirmationModal
        isOpen={mergeShutterConfirmationOpen}
        toggle={toggleMergeShutterConfirmation}
        onConfirm={() => mergeSelectedShutter()}
        message="Are you sure you want to merge the selected shutters"
        headingText="Merge Shutters"
      />
      <ConfirmationModal
        isOpen={showMessageOnTemplateChange.show}
        toggle={() =>
          setShowMessageOnTemplateChange({ show: false, message: "", args: {} })
        }
        onConfirm={() => changeModuleTemplate(showMessageOnTemplateChange.args)}
        message={`${showMessageOnTemplateChange.message}`}
        headingText="Change Module"
      />
      <ConfirmationModal
        isOpen={showClearSpaceConfirmation}
        toggle={toggleClearAllSpaceConfirmation}
        onConfirm={() => handleClearRootSpace()}
        message="Are you sure you want to clear the space in this module?"
        headingText="Clear space in module"
      />
    </>
  );
};

export default RightPanel;
